import type { RankingEntry } from '@killer-party/contracts';

export interface AgentCounts {
  inGame: number;
  out: number;
  total: number;
}

// Hors jeu : elimines (FAILED) et abandons (ABORTED). Les agents partis du lobby
// ne figurent deja plus au classement (TD-016).
export function agentCounts(ranking: Pick<RankingEntry, 'statusCode'>[]): AgentCounts {
  const out = ranking.filter(
    ({ statusCode }) => statusCode === 'FAILED' || statusCode === 'ABORTED',
  ).length;
  return { inGame: ranking.length - out, out, total: ranking.length };
}
